import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EntryComplement from './EntryComplement';
import InfoTotalValue from './InfoTotalValue';

type LaunchDetailsBoxProps = {
  totalValue?: string | number | null;
  launchComplement?: string;
  setLaunchComplement?: (value: string) => void;
  complementDisabled?: boolean;
};

export default function LaunchDetailsBox({
  totalValue,
  launchComplement,
  setLaunchComplement,
  complementDisabled = false,
}: LaunchDetailsBoxProps) {
  const theme = useTheme();
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        display: 'block',
        flexDirection: 'row',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'block', minWidth: theme.spacing(31), mb: 2 }}>
        {launchComplement !== undefined && (
          <EntryComplement
            label={t('entry.complement')}
            value={launchComplement}
            onChange={setLaunchComplement}
            disabled={complementDisabled}
          />
        )}

        <Box sx={{ mt: 1 }}>
          {totalValue !== undefined && totalValue !== null && (
            <InfoTotalValue label={t('launch.entry.value') as string} value={totalValue} />
          )}
        </Box>
      </Box>
    </Box>
  );
}
